module.exports = require("./os-RU");